export default __webpack_public_path__ + "static/media/largehealthpot.f14378df.PNG";